module.exports = ".metadata{\r\n    vertical-align: top !important;\r\n    font-size: smaller;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/downloads/downloads.component.css
// module id = ./src/app/components/downloads/downloads.component.css
// module chunks = main